export const BellIconStrikeThrough: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      stroke="currentColor"
      {...props}
    >
      <path
        id="Vector"
        d="M2.125 13.5V12H3.125V7C3.125 6.43056 3.21875 5.88542 3.40625 5.36458C3.59375 4.84375 3.84722 4.35417 4.16667 3.89583L5.27083 5C5.0625 5.29167 4.90278 5.60938 4.79167 5.95312C4.68056 6.29688 4.625 6.64583 4.625 7V12H10.125L0 1.875L1.0625 0.791667L15.1875 14.9375L14.125 16L11.625 13.5H2.125ZM13.125 10.75L11.625 9.25V7C11.625 6.02778 11.2847 5.20139 10.6042 4.52083C9.92361 3.84028 9.09722 3.5 8.125 3.5C7.80778 3.5 7.50278 3.54167 7.21 3.625C6.91722 3.70833 6.63194 3.82639 6.35417 3.97917L5.27083 2.88521C5.54861 2.68396 5.84375 2.52083 6.15625 2.39583C6.46875 2.27083 6.79167 2.17361 7.125 2.10417V1C7.125 0.722222 7.22222 0.486111 7.41667 0.291667C7.61111 0.0972222 7.84722 0 8.125 0C8.40278 0 8.63889 0.0972222 8.83333 0.291667C9.02778 0.486111 9.125 0.722222 9.125 1V2.10417C10.3056 2.32639 11.2674 2.89583 12.0104 3.8125C12.7535 4.72917 13.125 5.79167 13.125 7V10.75ZM8.12063 16C7.70688 16 7.35417 15.8531 7.0625 15.5594C6.77083 15.2656 6.625 14.9125 6.625 14.5H9.625C9.625 14.9167 9.47771 15.2708 9.18312 15.5625C8.88854 15.8542 8.53438 16 8.12063 16Z"
      />
    </svg>
  );
};
